/**
import all locale translation from different module
and export from this file.
 **/
import homepage from '@/Homepage/langs/zh_hk'
import auth from '@/Auth/langs/zh_hk'
import error from '@/ErrorPage/langs/zh_hk'
import fitComponents from '@/components/langs/zh_hk'
import validation from '@/Validation/langs/zh_hk'
import product from '@/Product/langs/zh_hk'
import cart from '@/Cart/langs/zh_hk'
import account from '@/Account/langs/zh_hk'
import payment from '@/Payment/langs/zh_hk'
import shop from '@/Shop/langs/zh_hk'

export default {
  hm: '主頁',
  general: {
    batchSelect: '多項選擇',
    selectable: '可選擇',
    submit: '提交',
    add: '添加',
    share:'分享',
    remove: '刪除',
    logout: '登出',
    language: '系統語言',
    updateSuccess: '更新成功。',
    updateError: '更新失敗，請稍後再試',
    deleteSuccess: '刪除成功。',
    selectDate: '請選擇日期',
    autoSearchText: '抱歉，無匹配選項',
    ok: '是',
    cancel: '取消',
    confirm: '確認',
    notification: '提示',
    message: '訊息',
    yes: '是',
    no: '否',
    save: '儲存',
    create: '創建',
    edit: '修改',
    pagination: {
      perPage: '每頁項目',
      items: '頁數 {page} / 總共 {total} 項目'
    },
    action: '行動',
    remind: '提醒',
    fromDate: '開始日期',
    toDate: '結束日期',
    clearFilter: '清除選項',

    search: '檢索關鍵字',
    total: '總共',
    records: '紀錄',
    all: '所有',
    more: '更多',
    date: '日期',
    perPage: '每頁',

    M: '男',
    F: '女',

    //CURD Text
    CURD: {
      create: '創建',
      edit: '修改',
      actions: '行動',
      update: '更新',
      retrieve: '查看',
      delete: '刪除',
      approve: '批准',
      reject: '拒絕',
      next: '下一步',
      complete: '完成',
      prev: '上一步',
      deleteConfirmMessage: '確認刪除這些紀錄嗎？',
      save: '儲存'
    },
    workflow: {
      next: '下一步',
      previous: '上一步',
      finish: '完成'
    },
    gender: '性別',
    dateOfBirth: '出生日期',
    identityCardNo: '身分證號碼',
    companyAddress: '公司註冊地址',
    correspondenceAddress: '聯絡地址',
    residentialAddress: '住址',
    email: '電子郵件',
    fax: '傳真',
    telephoneMobile: '手提電話',
    telephoneHome: '住宅電話',
    telephoneOffice: '辦公室電話',
    processing: '進行中'
  },
kol:{
    promote: '推廣價: ',
    choose: '-- 請選擇商品 --',
    title:'網紅熱購',
    loadingMsg:'加載中...',
    registeringMsg:'註冊中...',
    priceUnit:'HKD',
    region:{
      region:'地區',
      selectText:'請選擇國家或地區',
      currentOption:'當前選擇',
      cn:'中國大陸',
      hk:'香港',
      mo:'澳門',
    },
    header:{ // new Text
      search:'搜索',
      cancel:'取消',
      confirm:'確認',
    },
    footer:{
      homepage:'首頁',
      fullList:'全部商品',
      shop: '精選推介',
      // shop: '我的推介',
      cart:'購物車',
      payment:'付款頁面',
      account:'我的賬戶',
      checkout: '提交訂單',
      orderList: '我的訂單',
      success: '付款成功',
      addressList: '地址列表',
      goBackAccount:'返回個人中心'
    },
    FITFileUpload: {
      select: '選擇文件',
      upload: '上傳文件',
      fileName: '文件名',
      size: '文件容量',
      publicDocument: '公開文件',
      isPublic: '公開',
      documentTag: '標籤',
      remarks: '備註',
      isDownloadable: '可供下載',
      remove: '刪除',
      preview:"預覽",
      dropFileMsg: '拉動文件至此用於上傳',
      uploadRemindMsg: '請務必於選擇文件完成後點選“上傳文件”',
      successMsg: '您的文件已成功上傳。',
      errorMsg: '您的文件上傳失敗，請稍候再試'
    },
  },
  home: homepage,
  auth,
  error,
  fitComponents,
  product,
  cart,
  account,
  payment,
  shop,
}



// WEBPACK FOOTER //
// ./src/langs/zh_hk/index.js